import { useMutation, useQueryClient } from '@tanstack/react-query';
import produce from 'immer';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import {
  CopyPersonalQuizToWorkspaceError,
  CopyPersonalQuizToWorkspaceParams,
  copyPersonalQuizToWorkspace,
} from '../../../api/workspaces/copyPersonalQuizToWorkspace';
import { WorkspaceQuiz } from '../../../api/workspaces/quiz/types';

export const addWorkspaceQuiz = produce(
  (state: WorkspaceQuiz[], newQuiz: WorkspaceQuiz) => {
    state.push(newQuiz);
  }
);

export function useCopyPersonalToWorkspace() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: copyPersonalQuizToWorkspace,
    onSuccess: (
      data: WorkspaceQuiz,
      { workspaceId }: CopyPersonalQuizToWorkspaceParams
    ) => {
      const workspaceQuizzes = queryClient.getQueryData<WorkspaceQuiz[]>(
        workspaceKeys.quizzes({ workspaceId: workspaceId })
      );

      if (!workspaceQuizzes) return;

      queryClient.setQueryData<WorkspaceQuiz[]>(
        workspaceKeys.quizzes({ workspaceId: workspaceId }),
        (state) =>
          addWorkspaceQuiz(state, {
            ...data,
          })
      );
    },
    onSettled: (
      data: WorkspaceQuiz,
      error: CopyPersonalQuizToWorkspaceError,
      { workspaceId }: CopyPersonalQuizToWorkspaceParams
    ) => {
      return queryClient.invalidateQueries(
        workspaceKeys.quizzes({ workspaceId: workspaceId }),
        { refetchType: 'active' }
      );
    },
  });
}
